export const urls = {
  VRATI_STAVKE: 'DokNarudzbineStavke/narudzbine_vrati_stavke',
  VRATI_DOKUMENTA: 'DokPonude/vrati_dok_ponude_za_id_veze',
  INSERT_PONUDE: 'DokPonude/unos_dok_ponude',
  EDIT_PONUDE: 'DokPonude/izmena_dok_ponude',
};
